<template>
  <main>
    <section class="wrap">
      <div class="bg">
        <img src="@/assets/img/login/building.png" width="100%" />
        <div class="wrap-box inter-box">
          <Logincomp ref="loginComp"></Logincomp>
        </div>
      </div>
      <div class="bg-right">
        <img src="@/assets/img/login/rightperson.png" />
      </div>
      <!--  <div class="bg-pic">
        <img src="@/assets/img/login/rightperson.png" />
      </div>-->
      <template v-if="!win.location.href.includes('qbookingsolutions')">
      <div class="reserved" v-if="win.location.hostname.includes('erentalcarpro.cn')">
        © 2011-2021 erentalcarpro.cn. All Rights Reserved. 广州力挚网络科技有限公司 版权所有
        营业执照 粤ICP备20049197号 粤公网安备 44010602000444号
      </div>
      <div class="reserved" v-if="win.location.hostname.includes('zuzuche.com')">
        © 2011-2021 zuzuche.com. All Rights Reserved. 广州力挚网络科技有限公司 版权所有 营业执照
        粤ICP备11007328号 粤公网安备 44010602000444号
      </div>
      <div class="reserved" v-if="win.location.hostname.includes('erentalcarpro.com')">
        © 2011-2021 erentalcarpro.com. All Rights Reserved. 广州力挚网络科技有限公司 版权所有
        营业执照 粤ICP备20049197号 粤公网安备 44010602000444号
      </div>
      </template>
    </section>
  </main>
</template>

<script>
import Logincomp from '@/common-comp/LoginComp.vue'
import { setRem } from '@/common/util-front.js'
export default {
  components: { Logincomp },
  data() {
    return {
      win: window
    }
  },
  async mounted() {
    this.setRem()
  },
  methods: {
    setRem(designWidth) {
      setRem()
      // 改变窗口大小时重新设置 rem
      window.onresize = function() {
        setRem()
      }
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/css/no-change.scss';
* {
  margin: 0;
  padding: 0;
}
.reserved {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 1rem;
  /* prettier-ignore */
  font-size: 12Px;
  text-align: center;
  color: #9e9e9e;
}
.wrap {
  position: relative;
  min-height: 100vh;
  .bg {
    position: relative;
    top: 0;
    height: 75%;
    /* prettier-ignore */
    min-height: 500Px;
    background: rgba(55, 101, 236, 1);
    img {
      height: 100%;
    }
  }
  .bg-right {
    position: absolute;
    width: 30%;
    right: 15%;
    bottom: 8%;
    img {
      width: 100%;
    }
  }
  .wrap-box {
    position: absolute;
    display: inline-block;
    width: 30%;
    /* prettier-ignore */
    min-width: 335Px;
    /* prettier-ignore */
    max-width: 450Px;
    padding: 0 46px 50px 46px;
    /* prettier-ignore */
    bottom: 80px;
    left: 220px;
    background: #fff;
    z-index: 999;
    .login-btn {
      background: #3665ec;
    }
    .change-txt {
      /* prettier-ignore */
      width: 30%;
      /* prettier-ignore */
      max-width: 90Px;
      user-select: none;
    }
  }
}
@media screen and (max-width: 1200px) {
  .bg-right {
    bottom: 14% !important;
  }
}
@media screen and (max-width: 710px) {
  .bg-right {
    display: none;
  }
  .wrap-box {
    left: 50% !important;
    transform: translateX(-50%);
  }
}
</style>
